import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const vaultToken = () => localStorage.getItem("vault_token");
export const adminToken = () => localStorage.getItem("admin_token");

export const vaultApi = () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${vaultToken()}` } });
export const adminApi = () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${adminToken()}` } });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const TYPE_META = {
  free_sc: { label: "Free SC", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  no_deposit: { label: "No Deposit", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  deposit: { label: "Deposit Match", cls: "bg-indigo-500/10 text-indigo-300 border-indigo-500/30" },
  daily_login: { label: "Daily Login", cls: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30" },
};

export function timeAgo(iso) {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 3600) return `${Math.floor(s / 60) || 1} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} hr ago`;
  return `${Math.floor(s / 86400)} days ago`;
}
